import React from 'react';
import { Box } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { ExternalProvider } from '../ExternalProviderContext';
import RequestLogsSearchFilters from './RequestLogsSearchFilters';
import RequestLogsContent from './RequestLogsContent';

export default function RequestLogsPage() {
  return (
    <ExternalProvider>
      <React.Fragment>
        <section className="slick-page-header-section">
          <Box className="filter-section" display="flex" flexWrap="nowrap" p={0} justifyContent="flex-start" px={1}>
            <Box p={1}>
              <FilterListIcon />
            </Box>
            <RequestLogsSearchFilters />
          </Box>
        </section>
        <RequestLogsContent />
      </React.Fragment>
    </ExternalProvider>
  );
}
